module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Marker":"Pin","You haven\u0027t set any pins yet":"Es wurden noch keine Pins festgelegt"}}')
  delete Component.options._Ctor
}
